module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Ben Strohm-2aee62cdc640ac3718dd17d9e5961f17.jpg";